import React from 'react';
export function Hero() {
  return <section id="hero" className="min-h-screen flex items-center justify-center text-center relative overflow-hidden pt-[120px] pb-[80px] px-5 bg-black" data-id="element-154">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_50%,rgba(201,168,76,0.06)_0%,transparent_60%),radial-gradient(ellipse_at_80%_50%,rgba(201,168,76,0.04)_0%,transparent_60%)]" data-id="element-155"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-full bg-gradient-to-b from-transparent via-gold/30 to-transparent" data-id="element-156"></div>

      <div className="relative z-10 max-w-[900px] w-full" data-id="element-157">
        <div className="inline-block text-[0.65rem] tracking-[6px] uppercase text-gold border border-gold/30 py-2 px-6 mb-[30px] font-semibold" data-id="element-158">
          Miami, Florida · Est. 2022
        </div>

        <h1 className="font-cinzel text-[clamp(3rem,8vw,7rem)] font-black leading-none text-white uppercase tracking-[6px] mb-2.5" data-id="element-159">
          SOLIDO
          <br data-id="element-160" />
          <span className="text-gold" data-id="element-161">TATTOO</span>
          <br data-id="element-162" />
          STUDIO
        </h1>

        <p className="font-cinzel text-[clamp(1rem,2.5vw,1.6rem)] text-gold tracking-[8px] uppercase mb-5" data-id="element-163">
          Art Lives on Skin
        </p>

        <div className="w-[80px] h-px bg-gradient-to-r from-transparent via-gold to-transparent mx-auto my-[25px]" data-id="element-164"></div>

        <p className="text-base text-gray leading-[1.8] max-w-[600px] mx-auto mb-10 font-light tracking-[1px]" data-id="element-165">
          Donde el arte se convierte en piel.{' '}
          <strong className="text-gold-light font-semibold" data-id="element-166">
            Más de 15 años de experiencia
          </strong>{' '}
          creando tatuajes únicos, con dominio absoluto del realismo en blanco y
          negro y color. Tu visión, nuestra maestría.
        </p>

        <div className="flex gap-5 justify-center flex-wrap" data-id="element-167">
          <a href="http://wa.me/15615275756" target="_blank" rel="noopener noreferrer" className="bg-gold text-black py-4 px-10 font-cinzel text-[0.75rem] font-bold tracking-[4px] uppercase relative overflow-hidden group transition-all duration-300 hover:bg-gold-light hover:-translate-y-0.5 hover:shadow-[0_10px_40px_rgba(201,168,76,0.4)]" data-id="element-168">
            <span className="absolute top-0 -left-full w-full h-full bg-white/20 transition-all duration-300 group-hover:left-full" data-id="element-169"></span>
            Agenda Tu Cita
          </a>
          <a href="#gallery" className="bg-transparent text-white py-4 px-10 font-cinzel text-[0.75rem] font-bold tracking-[4px] uppercase border border-white/20 transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-0.5" data-id="element-170">
            Ver Trabajos
          </a>
        </div>

        <div className="flex justify-center gap-[30px] md:gap-[60px] mt-[70px] pt-10 border-t border-gold/10 flex-wrap" data-id="element-171">
          <div className="text-center" data-id="element-172">
            <span className="font-cinzel text-[2.2rem] font-black text-gold block" data-id="element-173">
              15+
            </span>
            <span className="text-[0.65rem] tracking-[3px] uppercase text-gray mt-1.5 block" data-id="element-174">
              Años de Experiencia
            </span>
          </div>
          <div className="text-center" data-id="element-175">
            <span className="font-cinzel text-[2.2rem] font-black text-gold block" data-id="element-176">
              500+
            </span>
            <span className="text-[0.65rem] tracking-[3px] uppercase text-gray mt-1.5 block" data-id="element-177">
              Clientes Satisfechos
            </span>
          </div>
          <div className="text-center" data-id="element-178">
            <span className="font-cinzel text-[2.2rem] font-black text-gold block" data-id="element-179">
              100%
            </span>
            <span className="text-[0.65rem] tracking-[3px] uppercase text-gray mt-1.5 block" data-id="element-180">
              Arte Original
            </span>
          </div>
          <div className="text-center" data-id="element-181">
            <span className="font-cinzel text-[2.2rem] font-black text-gold block" data-id="element-182">
              ∞
            </span>
            <span className="text-[0.65rem] tracking-[3px] uppercase text-gray mt-1.5 block" data-id="element-183">
              Estilos Disponibles
            </span>
          </div>
        </div>
      </div>
    </section>;
}